import React from 'react';
import PropTypes from 'prop-types';
import { DateWithoutTimeZone } from '@common/components';
import { StateBadge } from 'works/legacy/components/state-badge';

const COLOR_STYLE_MAP = {
  available: 'hypnotiq',
  unavailable: 'midnight-lighter',
  doNotRehire: 'coral',
  unavailableDoNotRehire: 'midnight-lighter',
};

const STATE_LABEL_MAP = {
  available: 'Available For Submission',
  unavailable: 'On Assignment',
  doNotRehire: 'Do Not Rehire',
  unavailableDoNotRehire: 'On Assignment [Do Not Rehire]',
};

function UnavailableCaption({ currentStaffingRequestAssignments }) {
  if (
    !currentStaffingRequestAssignments ||
    currentStaffingRequestAssignments.length === 0
  )
    return null;

  return (
    <ul className="UnavailableCaption">
      {currentStaffingRequestAssignments.map((assignment) => {
        return (
          <li key={assignment.id}>
            <DateWithoutTimeZone date={assignment.startDate} />
            -
            <DateWithoutTimeZone date={assignment.endDate} />
          </li>
        );
      })}

      <style jsx>{`
        .UnavailableCaption {
          margin: 0;
          padding-left: 12px;
          font-weight: 400;
        }
      `}</style>
    </ul>
  );
}

UnavailableCaption.propTypes = {
  currentStaffingRequestAssignments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      startDate: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
      ]),
      endDate: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
      ]),
    })
  ),
};

UnavailableCaption.defaultProps = {
  currentStaffingRequestAssignments: [],
};

export function AvailabilityStateBadge({
  available,
  doNotRehire,
  currentStaffingRequestAssignments,
}) {
  let state;

  if (doNotRehire && available) {
    state = 'doNotRehire';
  } else if (doNotRehire && !available) {
    state = 'unavailableDoNotRehire';
  } else if (available) {
    state = 'available';
  } else {
    state = 'unavailable';
  }

  return (
    <StateBadge
      state={STATE_LABEL_MAP[state]}
      caption={
        !available && (
          <UnavailableCaption
            currentStaffingRequestAssignments={
              currentStaffingRequestAssignments
            }
          />
        )
      }
      color={COLOR_STYLE_MAP[state]}
    />
  );
}

AvailabilityStateBadge.propTypes = {
  available: PropTypes.bool,
  currentStaffingRequestAssignments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      startDate: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
      ]),
      endDate: PropTypes.oneOfType([
        PropTypes.instanceOf(Date),
        PropTypes.string,
      ]),
    })
  ),
  doNotRehire: PropTypes.bool.isRequired,
};
